module.exports = __webpack_public_path__ + "static/media/homepage_atf_2_mo_en.27bc11a7.png";